import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../images/Logo';
import { Icon } from '../../ui';
import styles from './AuthLayout.module.css';

export type AuthLayoutProps = {
  titulo: string;
  subtitulo?: string;
  children: ReactNode;
};

const destaques = [
  { icone: 'donut_small', texto: 'Clareza de pra onde vai cada real, categoria por categoria' },
  { icone: 'insights', texto: 'Previsibilidade: saiba hoje como o seu mês vai terminar' },
  { icone: 'task_alt', texto: 'Contas, cartões e metas num só lugar, sem planilha nem fórmula quebrada' }
];

/**
 * Layout compartilhado das telas de autenticação (/entrar, /criar-conta,
 * /recuperar-senha, /definir-senha): coluna de formulário à esquerda e painel
 * de marca com o pitch do produto à direita (escondido em telas ≤900px).
 */
export default function AuthLayout({ titulo, subtitulo, children }: AuthLayoutProps) {
  return (
    <div className={styles.pagina}>
      <div className={styles.colunaForm}>
        <div className={styles.formInterno}>
          <Link to="/" className={styles.marca} aria-label="Voltar para a página inicial">
            <Logo className={styles.logo} />
            <span className={styles.nomeMarca}>Finant</span>
          </Link>

          <header className={styles.cabecalho}>
            <h1 className={styles.titulo}>{titulo}</h1>
            {subtitulo && <p className={styles.subtitulo}>{subtitulo}</p>}
          </header>

          <div className={styles.conteudo}>{children}</div>

          <footer className={styles.rodape}>
            <Link to="/termos-e-politicas" className={styles.linkRodape}>
              Termos e políticas
            </Link>
          </footer>
        </div>
      </div>

      <aside className={styles.painelMarca}>
        <div className={styles.circulo1} />
        <div className={styles.circulo2} />
        <div className={styles.circulo3} />

        <div className={styles.pitch}>
          <h2 className={styles.pitchTitulo}>Seu dinheiro, finalmente sob controle.</h2>
          <p className={styles.pitchTexto}>
            O Finant mostra pra onde o seu dinheiro está indo e como o mês vai fechar, antes de ele
            acontecer. Decida com calma, não descubra no susto.
          </p>

          <ul className={styles.pitchLista}>
            {destaques.map((item) => (
              <li key={item.icone} className={styles.pitchItem}>
                <span className={styles.pitchIcone}>
                  <Icon nome={item.icone} tamanho={16} cor="rgba(255, 255, 255, 0.95)" />
                </span>
                <span>{item.texto}</span>
              </li>
            ))}
          </ul>

          <figure className={styles.depoimento}>
            <blockquote className={styles.depoimentoTexto}>
              Gastos até agora: R$ 2.418 de R$ 3.200 planejados. No ritmo atual, seu mês fecha no
              azul, com R$ 782 de folga.
            </blockquote>
            <figcaption className={styles.depoimentoAutor}>
              <span className={styles.depoimentoAvatar}>R$</span>
              <span>
                <span className={styles.depoimentoNome}>Previsão do mês</span>
                <span className={styles.depoimentoPapel}>exemplo de como você verá o seu dinheiro</span>
              </span>
            </figcaption>
          </figure>
        </div>
      </aside>
    </div>
  );
}
